import { observable, runInAction, computed } from 'mobx'
import Api from '@api/decoration'
import { getMerchantInfo } from '@util'

class Store {
  @observable list = []
  @observable total_count = 0

  getList = async () => {
    const { data, success } = await Api.getJiaMengGoods({
      merchant_id: getMerchantInfo().id
    })
    runInAction(() => {
      if (success) {
        this.list = data.list || []
        this.total_count = data.total_count || 0
      }
    })
  }

  @computed
  get fakeMode() {
    return this.total_count <= 0
  }

  fakeData = [
    {
      property_id: '6',
      kind: '1',
      list: [
        {
          id: '1',
          hot_tag: '1'
        },
        {
          id: '2',
          hot_tag: '2'
        },
        {
          id: '3',
          hot_tag: '3'
        }
      ]
    },
    {
      property_id: '12',
      kind: '1',
      list: [
        {
          id: '1'
        },
        {
          id: '2'
        },
        {
          id: '3'
        },
        {
          id: '4'
        }
      ]
    },
    {
      property_id: '0',
      kind: '2',
      list: [
        {
          id: '1'
        },
        {
          id: '2'
        },
        {
          id: '3'
        },
        {
          id: '4'
        }
      ]
    }
  ]
}

export default Store
